export const RESCHEDULE_CLASSES_FILTERS = {
  primaryInstructors: 'primaryInstructors',
  secondaryInstructors: 'secondaryInstructors',
  academyModules: 'academyModules',
  classType: 'classType',
  lectureType: 'lectureType',
  fromDate: 'fromDate',
  toDate: 'toDate',
};
